import { DevicesSelectionViewModel } from '../../Utils/DeviceSelections'
/**
 * This will hold the global state for the selected devices
 * @param state
 * @param action
 * @returns
 */
export function devicesSelection
    (state = DevicesSelectionViewModel.initEmptyDevicesSelection() , action: any) {
    switch (action.type) {
        case 'DEVICES_SELECTION':
            return action.data;
        default:
            return state;
    }
}
